import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-dialog-user-review-history',
    templateUrl: './dialog-user-review-history.component.html',
    styleUrls: ['./dialog-user-review-history.component.css'],
    standalone: false
})
export class DialogUserReviewHistoryComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogUserReviewHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
  }

  onClick(): void {
    this.dialogRef.close();
  }

}
